import React from 'react';
import {
  Button,
  UncontrolledTooltip,
} from 'reactstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import { useShowRealNames } from './scorekeeperPrefs';

export const RealNamesToggle = () => {
  const [showRealNames, setShowRealNames] = useShowRealNames();

  return (
    <Button
      id="show-real-names"
      type="button"
      className="mb-1"
      onClick={() => setShowRealNames(!showRealNames)}
      color="link"
      style={{ color: 'unset' }}
    >
      <UncontrolledTooltip
        placement="top"
        target="show-real-names"
      >
        {showRealNames ? 'Click to show MIST IDs' : 'Click to show real names'}
      </UncontrolledTooltip>
      {showRealNames ? <FaEye /> : <FaEyeSlash />}
    </Button>
  );
};
